import { useEffect, useState } from "react";
import { useApolloClient } from "@apollo/react-hooks";
import { GET_MACHINES_BY_IDS, GET_MACHINE_NAME_BY_ID } from "../CCCarbonMetal/components/CarbonMetalProcess/components/getStepDetail";

export const useGetMachineName = (machine_id) => {
  const client = useApolloClient();
  const [machineName, setMachineName] = useState("");

  useEffect(() => {
    const getMachineName = () => {
      client
        .query({
          query: GET_MACHINE_NAME_BY_ID,
          variables: { machine_id: machine_id },
        })
        .then(({ data }) => {
          setMachineName(data?.getMachineNameById?.name || "");
        })
        .catch((error) => {
          console.log("Error: ", error);
        });
    };
    getMachineName();
  }, []);
  return machineName;
};

export const useGetMachineDetails = (machine_ids) => {
  const client = useApolloClient();
  const [machineDetails, setMachineDetails] = useState({});
  const [machineDetailsArray, setMachineDetailsArray] = useState([]);

  useEffect(() => {
    if (!machine_ids || machine_ids.length === 0) {
      return;
    }

    // Filter out invalid IDs and ensure uniqueness
    const validIds = [...new Set(machine_ids.filter(id => id && !isNaN(id) && id > 0))];
    
    if (validIds.length === 0) {
      return;
    }

    const getMachines = () => {
      client
        .query({
          query: GET_MACHINES_BY_IDS,
          variables: { machine_ids: validIds },
        })
        .then(({ data }) => {
          const machines = data?.getMachinesByIds || [];
          // Create a map for easy lookup by machine_id
          const machineMap = {};
          machines.forEach(machine => {
            if (machine?.machine_id) {
              machineMap[machine.machine_id] = machine;
            }
          });
          setMachineDetails(machineMap);
          setMachineDetailsArray(machines);
        })
        .catch((error) => {
          console.log("Error: ", error);
        });
    };
    getMachines();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [machine_ids?.join(',')]);

  return { machineDetails, machineDetailsArray };
};
